import {
  ActivityIcon,
  BellIcon,
  SlidersIcon,
  PlugIcon,
  CarIcon,
  FingerprintIcon,
} from '../components/Icons';

/**
 * The long tail. The three headline capabilities (live, history, diagnostics)
 * each get their own section above with a graphic; these are the everything-
 * else items that would otherwise dilute them.
 */
const features = [
  {
    icon: SlidersIcon,
    title: 'Remote commands',
    desc: 'Lock, climate, charging and more. Every command is signed before it reaches your car, and every one is logged.',
  },
  {
    icon: BellIcon,
    title: 'Alerts',
    desc: 'Alerts straight from the car, kept and de-duplicated, with when each one was first and last seen.',
  },
  {
    icon: PlugIcon,
    title: 'Charging history',
    desc: 'Wall Connector sessions with energy, duration and an estimated cost. Tesla reports these late, so they fill in over a day or so.',
  },
  {
    icon: CarIcon,
    title: 'Multiple vehicles',
    desc: 'Switch between the cars in your garage and keep each one\u2019s view where you left it.',
  },
  {
    icon: FingerprintIcon,
    title: 'Passkey sign-in',
    desc: 'No passwords. Sign in with a passkey on your device — phishing-resistant by design.',
  },
  {
    icon: ActivityIcon,
    title: 'Raw signal log',
    desc: 'Every signal your car has sent, newest first — the raw data behind every chart here.',
  },
];

export default function Features(): JSX.Element {
  return (
    <section id="more" className="container-page pb-20 md:pb-28">
      <div className="mx-auto max-w-2xl text-center">
        <p className="eyebrow">Also included</p>
        <h2 className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl">
          Everything else it does
        </h2>
        <p className="mt-4 text-lg text-muted">
          Built on Tesla’s Fleet API and Fleet Telemetry — the same data your car
          streams, made useful.
        </p>
      </div>
      <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {features.map(({ icon: Icon, title, desc }) => (
          <div key={title} className="card h-full">
            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent/10 text-accent">
              <Icon className="h-6 w-6" />
            </div>
            <h3 className="mt-4 font-semibold">{title}</h3>
            <p className="mt-1.5 text-sm leading-relaxed text-muted">{desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
